<template>
    <div class="animated fadeIn">
        <b-card class="piplines-list">
            <b-card-header class="card-header-main">
                <b-row class="piplines-list-header">
                    <b-col>
                        <strong>Your Projects</strong>
                    </b-col>
                    <b-col md="2">
                        <router-link to="/iam/projects/create">
                            <b-button variant="primary" class="text-nowrap">
                                <i class="icon-plus mr-1"></i>Add new Project
                            </b-button>
                        </router-link>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <v-server-table
                    :url="table.apiUrl"
                    :columns="table.columns"
                    :options="table.options"
                    :theme="table.theme"
                    ref="owned-projects-table"
                    class="server-table"
                >
                    <div slot="actions" slot-scope="props" class="button-row">
                        <DetailsAction :routerLink="'/iam/projects/' + props.row.id" />
                    </div>
                </v-server-table>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import store from '../../../store/index'
import Vue from 'vue'
import {ServerTable} from 'vue-tables-2'
Vue.use(ServerTable)

import DetailsAction from '@/components/Actions/DetailsAction.vue'

export default {
    template: 'default',
    data() {
        return {
            table: {
                apiUrl: `${process.env.VUE_APP_NODE_API_HOST}/projects`,
                columns: ['name', 'actions'],
                theme: 'bootstrap4',
                options: {
                    requestFunction: function(data) {
                        return this.axios
                            .get(this.url, {
                                params: data,
                            })
                            .catch(
                                function(e) {
                                    this.dispatch('error', e)
                                }.bind(this)
                            )
                    },
                    responseAdapter: function(resp) {
                        const data = resp.data
                        return {
                            data: data.data,
                            count: data.metadata.count,
                        }
                    },
                    orderBy: {
                        ascending: false,
                    },
                    filterable: false,
                    sortable: [],
                    rowClassCallback: () => 'main-row',
                },
            },
        }
    },
    components: {
        ServerTable,
        DetailsAction,
    },
    methods: {},
}
</script>
